import ArticleIcon from '@mui/icons-material/Article';

const resource = {
  icon: ArticleIcon,
}
  
export default resource
